"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractSetupIntentId = void 0;
const extractSetupIntentId = (setupIntentClientSecret) => {
    const setupIntentId = setupIntentClientSecret.split("_secret_")[0];
    if (!setupIntentId) {
        return setupIntentClientSecret;
    }
    return setupIntentId;
};
exports.extractSetupIntentId = extractSetupIntentId;
//# sourceMappingURL=setup-intent.js.map